import React, { memo } from 'react';

import { Box } from '@mui/material';
import CustomFieldsSection from 'app/shared/components/customFields/CustomFieldsSection';
import PropTypes from 'prop-types';

import { rowCustomFieldsWrapperStyles } from './RowCustomFields.styles';

const RowCustomFields = ({ applicationId, customFieldsController, target, targetEntityId }) => {
  const { definitions } = customFieldsController;

  if (!definitions.length) {
    return null;
  }

  return (
    <Box sx={rowCustomFieldsWrapperStyles}>
      <CustomFieldsSection
        applicationId={applicationId}
        controller={customFieldsController}
        target={target}
        targetEntityId={targetEntityId}
      />
    </Box>
  );
};

RowCustomFields.propTypes = {
  applicationId: PropTypes.string.isRequired,
  customFieldsController: PropTypes.shape({
    definitions: PropTypes.array.isRequired,
    formValues: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
  }).isRequired,
  target: PropTypes.string.isRequired,
  targetEntityId: PropTypes.string.isRequired,
};

export default memo(RowCustomFields);
